import { render, staticRenderFns } from "./DealerShopView.vue?vue&type=template&id=abbfa084&scoped=true&"
import script from "./DealerShopView.vue?vue&type=script&lang=js&"
export * from "./DealerShopView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbfa084",
  null
  
)

export default component.exports